import api from './api';

export async function getVenueBookings(venueId, params) {
  const response = await api.get(`/venues/${venueId}/bookings`, { params });
  return response.data;
}

export async function getBookingById(id) {
  const response = await api.get(`/bookings/${id}`);
  return response.data;
}

export async function cancelBooking(id, reason) {
  const response = await api.post(`/bookings/${id}/cancel`, { reason });
  return response.data;
}

export async function rescheduleBooking(id, newStartTime, newEndTime, newCourtId) {
  const response = await api.post(`/bookings/${id}/reschedule`, {
    newStartTime,
    newEndTime,
    newCourtId,
  });
  return response.data;
}

export async function getVenueAvailability(venueId, date) {
  const response = await api.get(`/venues/${venueId}/availability`, {
    params: { date },
  });
  return response.data;
}

export async function checkInPlayer(bookingId) {
  const response = await api.post(`/bookings/${bookingId}/check-in`);
  return response.data;
}

export async function completeBooking(bookingId) {
  const response = await api.post(`/bookings/${bookingId}/complete`);
  return response.data;
}

export async function modifyBooking(bookingId, data) {
  const response = await api.put(`/bookings/${bookingId}`, data);
  return response.data;
}

export async function createManualBooking(data) {
  const response = await api.post('/bookings/manual', data);
  return response.data;
}
